'use client';

import { Box, Card, CardMedia, Grid, GridItem } from '@coolblue-development/freddy';
import goToSupportHubTrigger from '@coolblue-development/ga4-events/triggers/HelpAfterPurchase/goToSupportHubTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { Image } from '@coolblue-development/next-image/client';
import { Product } from '@features/product/typings';
import { MainProduct } from '@features/second-chance/typings';
import { useTranslation } from '@i18n/useTranslation';

const AdviceEntrances = ({
  product,
  productSupportUrl
}: {
  product: Product | MainProduct;
  productSupportUrl: string;
}) => {
  const { t } = useTranslation('webshop');
  const { trackEvent } = useAnalytics();
  const params: Parameters<typeof goToSupportHubTrigger>[0] = {
    sub_feature: 'less_prominent',
    item_id: product.id
  };

  if (!product.hasProductSupportHub || !product.productType.image?.id) {
    return null;
  }

  return (
    <Box component='section'>
      <Grid gap={400}>
        <GridItem column={{ xs: 'span 12', sm: 'span 10', md: 'span 6' }}>
          <Box onClick={() => trackEvent(goToSupportHubTrigger(params))}>
            <Card
              href={productSupportUrl}
              orientation='horizontal'
              header={
                <CardMedia
                  aspectRatio='1/1'
                  image={
                    <Image
                      imageId={product.productType.image.id}
                      width={200}
                      height={200}
                      background='transparent'
                      alt='' // This image is not relevant for accessibility
                      loading='lazy'
                      fileCollection='content'
                      objectFit='cover'
                    />
                  }
                />
              }
              title={t('productPage.productInformation.supportCardTitle')}
              linkProps={{ rel: 'nofollow' }}
            />
          </Box>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default AdviceEntrances;
